export const programs = [
  {
    element: '.programs_page',
    popover: {
      title: 'Programs',
      description: "Welcome to your Programs section, where you list and manage all your academic offerings. Setting up your programs here is key to unlocking precise marketing campaign tracking, allowing you to see exactly which efforts are driving your <b>marketing metrics</b> for each individual program. For example, you'll know precisely how a Facebook post promoting your ",
      position: 'top',
    },
  },  {
    element: '.create_program_btn',
    popover: {
      title: 'Create Program',
      description: "This is where you'll add <b>each of your school's academic programs</b> into University Intelligence. It's vital to include every offering, as this step ensures we can provide <b>precise, program-specific marketing insights</b> for your entire institution.",
      position: 'right',
    },
  },
  // {
  //   element: '.program_list',
  //   popover: {
  //     title: 'Programs List',
  //     description: 'Here you’ll find all the programs created by the selected client. Programs represent courses like B.E, BCA, BBA, or MCA.',
  //     position: 'right',
  //   },
  // },
    {
    element: '.campaigns',
    popover: {
      title: 'Campaigns',
      description: 'Go to the Campaigns section by clicking here.',
      position: 'right',
    },
  },

];



    